"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _PerAdditionalUnitSubtext = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/PerAdditionalUnitSubtext"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var _PriceBreakdownRow = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/PriceBreakdownRow"));

var _merchUtils = require("self-service-api/core/utilities/merchUtils");

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _Terms = require("self-service-api/constants/Terms");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _PromotionSelectors = require("../../selectors/PromotionSelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _UnitTypes = require("pricing-pages-unified-ui/constants/UnitTypes");

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 0 25px 10px 25px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MODAL_WIDTH = 600;

var ModalBody = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakdownModal__ModalBody",
  componentId: "i0pzvc-0"
})(_templateObject()); // TODO we should remove this helper, dynamic string keys are bad for static analysis


var _getLang = function _getLang(path) {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator." + path
  });
};

var PriceBreakdownModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PriceBreakdownModal, _React$Component);

  function PriceBreakdownModal() {
    (0, _classCallCheck2.default)(this, PriceBreakdownModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PriceBreakdownModal).apply(this, arguments));
  }

  (0, _createClass2.default)(PriceBreakdownModal, [{
    key: "getAdditionalUnitPricePerMonth",
    value: function getAdditionalUnitPricePerMonth() {
      var _this$props = this.props,
          activeMerchId = _this$props.activeMerchId,
          termId = _this$props.termId,
          activeCurrencyCode = _this$props.activeCurrencyCode;
      return _react.default.createElement(_Small.default, {
        use: "help"
      }, !this.props.isGrowthSuite && _react.default.createElement(_PerAdditionalUnitSubtext.default, {
        merchId: activeMerchId,
        termId: termId,
        currencyCode: activeCurrencyCode
      }));
    }
  }, {
    key: "getPriceSubtext",
    value: function getPriceSubtext() {
      var activeTerm = this.props.activeTerm;
      return _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.calculator.priceBreakdown.priceSubtextParentheses." + activeTerm
      }));
    }
  }, {
    key: "getAdjustedQuantity",
    value: function getAdjustedQuantity(merchId, quantity) {
      var products = this.props.products;
      var isMarketingContacts = products[merchId].units === _UnitTypes.MARKETING_CONTACT;

      if (_MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId) && !isMarketingContacts) {
        return (0, _merchUtils.getAdditionalUnitsQuantityMinusIncluded)(products, quantity, merchId);
      }

      return quantity;
    }
  }, {
    key: "getBillingName",
    value: function getBillingName(merchId, quantity) {
      var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchId]; // Note: quantity may not always be used in the billingNameKey string,
      //       but there should always be a quantity we can pass

      return _react.default.createElement(_FormattedMessage.default, {
        message: "pricing-pages.billingNames." + billingNameKey,
        options: {
          count: quantity
        }
      });
    }
  }, {
    key: "getProductDescriptionSubtext",
    value: function getProductDescriptionSubtext(billingNameKey) {
      var message = "pricingPage.calculator.priceBreakdown.onboardingValueProps." + billingNameKey;
      if ((0, _isValidI18nKey.default)(message)) return _react.default.createElement(_Small.default, {
        use: "help",
        style: {
          fontStyle: 'italic'
        }
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: message
      }));
      return undefined;
    }
  }, {
    key: "renderRecurringFees",
    value: function renderRecurringFees() {
      var _this = this;

      var _this$props2 = this.props,
          recurringMerchPriceBreakdown = _this$props2.recurringMerchPriceBreakdown,
          activeCurrencyCode = _this$props2.activeCurrencyCode,
          isGrowthSuite = _this$props2.isGrowthSuite;
      return recurringMerchPriceBreakdown.map(function (recurringMerch) {
        if (recurringMerch.calculatedPrice === 0) return null;
        var monthlyPriceObj = recurringMerch.monthly;

        var _monthlyPriceObj$pric = (0, _slicedToArray2.default)(monthlyPriceObj.priceBreakdown, 2),
            baseMerch = _monthlyPriceObj$pric[0],
            _monthlyPriceObj$pric2 = _monthlyPriceObj$pric[1],
            additionalUnitMerch = _monthlyPriceObj$pric2 === void 0 ? null : _monthlyPriceObj$pric2; // Need to adjust quantity bc we only want to display *additional* contacts
        // not *total* contacts


        var adjustedAdditionalUnitQuantity = additionalUnitMerch ? _this.getAdjustedQuantity(additionalUnitMerch.merchandiseId, additionalUnitMerch.quantity) : null;
        return _react.default.createElement(_react.default.Fragment, {
          key: baseMerch.merchandiseId
        }, _react.default.createElement(_PriceBreakdownRow.default, {
          price: // want all of the growth suite recurring fees to be full price
          // and then show discount after totaled at the bottom
          isGrowthSuite ? baseMerch.fullPrice : baseMerch.calculatedPrice,
          currencyCode: activeCurrencyCode,
          priceDisclaimer: _this.getPriceSubtext(),
          text: _this.getBillingName(baseMerch.merchandiseId, baseMerch.quantity),
          isMonthly: true,
          subtext: _this.getAdditionalUnitPricePerMonth()
        }), adjustedAdditionalUnitQuantity > 0 && _react.default.createElement(_PriceBreakdownRow.default, {
          price: isGrowthSuite ? additionalUnitMerch.fullPrice : additionalUnitMerch.calculatedPrice,
          currencyCode: activeCurrencyCode,
          priceDisclaimer: _this.getPriceSubtext(),
          text: _this.getBillingName(additionalUnitMerch.merchandiseId, adjustedAdditionalUnitQuantity),
          isMonthly: true,
          subtext: _this.getAdditionalUnitPricePerMonth()
        }));
      });
    }
  }, {
    key: "renderOneTimeFees",
    value: function renderOneTimeFees() {
      var _this2 = this;

      var _this$props3 = this.props,
          activeCurrencyCode = _this$props3.activeCurrencyCode,
          oneTimeMerchPriceBreakdown = _this$props3.oneTimeMerchPriceBreakdown;

      if (!oneTimeMerchPriceBreakdown || !oneTimeMerchPriceBreakdown.length) {
        return null;
      }

      return _react.default.createElement("div", null, _react.default.createElement(_H.default, {
        className: "text-left m-left-7 m-bottom-0"
      }, _getLang('priceBreakdown.oneTimeFees')), oneTimeMerchPriceBreakdown.map(function (oneTimeMerch) {
        if (oneTimeMerch.calculatedPrice === 0) return null;
        var merchandiseId = oneTimeMerch.priceBreakdown[0].merchandiseId;
        var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchandiseId];
        var isBuyingNov2019Onboarding = merchandiseId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 || merchandiseId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019;
        return _react.default.createElement("div", {
          key: merchandiseId
        }, _react.default.createElement(_PriceBreakdownRow.default, {
          price: oneTimeMerch.calculatedPrice,
          fullPrice: oneTimeMerch.fullPrice,
          currencyCode: activeCurrencyCode,
          priceDisclaimer: _react.default.createElement(_Small.default, {
            use: "help"
          }, // Hacky 11/1 logic to show the promotional subtext only for the discounted onboarding SKUs
          isBuyingNov2019Onboarding ? _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
            message: "pricingPage.calculator.priceBreakdown.fiftyPercentPromoSubtext"
          }), _react.default.createElement("br", null)) : null, _react.default.createElement(_FormattedMessage.default, {
            message: "pricingPage.notes.oneTimeFeeParentheses"
          })),
          text: _react.default.createElement(_FormattedMessage.default, {
            message: "pricing-pages.billingNames." + billingNameKey
          }),
          subtext: _this2.getProductDescriptionSubtext(billingNameKey)
        }));
      }));
    }
  }, {
    key: "renderTotalCosts",
    value: function renderTotalCosts() {
      var _this$props4 = this.props,
          pricingInfo = _this$props4.pricingInfo,
          activeCurrencyCode = _this$props4.activeCurrencyCode,
          estimatedCostToGetStarted = _this$props4.estimatedCostToGetStarted,
          fullCostToGetStarted = _this$props4.fullCostToGetStarted,
          isGrowthSuite = _this$props4.isGrowthSuite,
          activeTerm = _this$props4.activeTerm;
      return _react.default.createElement("div", {
        style: {
          width: '100%'
        }
      }, _react.default.createElement(_PriceBreakdownRow.default, {
        text: _getLang('priceBreakdown.monthlyCost'),
        price: pricingInfo.monthly.calculatedPrice,
        fullPrice: isGrowthSuite && pricingInfo.monthly.fullPrice,
        currencyCode: activeCurrencyCode,
        isMonthly: true,
        isTotal: true,
        priceDisclaimer: this.getPriceSubtext()
      }), activeTerm === _Terms.ANNUAL && _react.default.createElement(_PriceBreakdownRow.default, {
        text: _getLang('priceBreakdown.subtotal'),
        price: pricingInfo.annually.calculatedPrice,
        fullPrice: isGrowthSuite && pricingInfo.annually.fullPrice,
        currencyCode: activeCurrencyCode,
        isYearly: true,
        isTotal: true,
        priceDisclaimer: _react.default.createElement(_Small.default, {
          use: "help"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "pricingPage.calculator.priceBreakdown.priceSubtextParentheses.monthlyX12"
        }))
      }), _react.default.createElement(_PriceBreakdownRow.default, {
        text: _getLang('priceDisplay.estimatedCostText'),
        price: estimatedCostToGetStarted,
        fullPrice: isGrowthSuite && fullCostToGetStarted,
        currencyCode: activeCurrencyCode,
        isTotal: true,
        priceDisclaimer: _react.default.createElement(_Small.default, {
          use: "help"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "pricingPage.calculator.priceDisplay.costSubtext." + activeTerm
        }))
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          onCloseClick = _this$props5.onCloseClick,
          isInMCBeta = _this$props5.isInMCBeta;
      return _react.default.createElement(_UIModal.default, {
        use: "conversational",
        width: MODAL_WIDTH
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onCloseClick
      }), _react.default.createElement(_H2.default, {
        className: "m-bottom-10"
      }, _getLang('priceBreakdown.modal'))), _react.default.createElement(ModalBody, null, _react.default.createElement(_H.default, {
        className: "text-left m-left-7 m-bottom-0"
      }, _getLang('priceBreakdown.recurringFees')), this.renderRecurringFees(), this.renderOneTimeFees(), _react.default.createElement(_HR.default, null), this.renderTotalCosts(), _react.default.createElement("div", {
        className: "p-all-7 text-center"
      }, _react.default.createElement(_Small.default, {
        use: "help"
      }, isInMCBeta ? _getLang('priceBreakdown.footerModalMC') : _getLang('priceBreakdown.footerModal')))));
    }
  }]);
  return PriceBreakdownModal;
}(_react.default.Component);

PriceBreakdownModal.propTypes = {
  onCloseClick: _propTypes.default.func.isRequired,
  pricingInfo: _propTypes.default.object.isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  recurringMerchPriceBreakdown: _propTypes.default.array.isRequired,
  oneTimeMerchPriceBreakdown: _propTypes.default.array,
  estimatedCostToGetStarted: _propTypes.default.number.isRequired,
  fullCostToGetStarted: _propTypes.default.number,
  activeTerm: _propTypes.default.string.isRequired,
  activeMerchId: _propTypes.default.number,
  termId: _propTypes.default.number.isRequired,
  isGrowthSuite: _propTypes.default.bool,
  products: _propTypes.default.object.isRequired,
  isInMCBeta: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var activeTerm = _ref.activeTerm,
      activeMerchId = _ref.activeMerchId,
      isGrowthSuite = _ref.isGrowthSuite,
      activeEdition = _ref.activeEdition;
  var termId = isGrowthSuite ? (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state)[activeEdition][activeTerm] : (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, activeTerm, activeMerchId);
  var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
  return {
    termId: termId,
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    isInMCBeta: isInMCBeta
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PriceBreakdownModal);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PriceBreakdownModal.js
// module id = 483
// module chunks = 5 6